import React from "react";

import styles from "./Team.module.scss";

const Team = () => {
  return (
    <div className={styles.layoutWrapper}>
      <h1>Our Team</h1>
    </div>
  );
};

export default Team;
